import React, { useMemo } from 'react';
import { curricula, trainingCatalog } from 'Data/Kontak/Training';
import {
  Box,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Avatar,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import RefreshIcon from '@mui/icons-material/Refresh';
import { gridSpacing } from 'config.js';

const PelatihanKurikulum = () => {
  const grouped = useMemo(() => {
    return curricula.reduce((acc, cur) => {
      acc[cur.training_id] = acc[cur.training_id] || [];
      acc[cur.training_id].push(cur);
      return acc;
    }, {});
  }, []);

  const getTrainingTitle = (id) => {
    const t = trainingCatalog.find((x) => x.id === id);
    return t ? t.title : id;
  };

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            transition: 'box-shadow 0.3s ease-in-out',
            '&:hover': { boxShadow: '0 12px 48px rgba(0,0,0,0.12)' }
          }}
          className="shadow-xl hover:shadow-2xl transition-shadow duration-300"
        >
          <CardHeader
            title={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }} className="shadow-lg">
                  <DescriptionIcon />
                </Avatar>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }} className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Kurikulum Pelatihan
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                    Modul dan durasi tiap pelatihan
                  </Typography>
                </Box>
              </Box>
            }
            action={
              <Button variant="outlined" startIcon={<RefreshIcon />}>Refresh</Button>
            }
            sx={{ pb: 2 }}
          />

          <Divider />

          <CardContent>
            {Object.keys(grouped).map((trainingId) => (
              <Box key={trainingId} sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>{getTrainingTitle(trainingId)}</Typography>
                <Paper sx={{ mt: 1 }}>
                  <List dense>
                    {grouped[trainingId].map((m) => (
                      <ListItem key={m.id} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                        <ListItemText primary={m.module} secondary={`${m.duration_minutes} menit`} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PelatihanKurikulum;
